// C4a.1 — machine marker placed in React Router ``location.state`` when the
// operator drills from the Analytics «Точность 24h» failure-category strip into
// the Feed. It carries ONLY the UX-return intent.
//
// Why location.state (not a query param):
//   * ``failure_category`` stays in the URL — it is the existing addressable
//     filter. The origin marker is deliberately NOT in the URL, so a shared /
//     deep-linked ``?failure_category=…`` link can never fake an Analytics-return
//     context, and a hard refresh (which drops history state) correctly loses
//     the «← В Аналитику» affordance + the scoped Telegram BackButton while the
//     URL filter persists. That is the intended safe contract.
//   * It never touches the backend filter — it is pure client-side UX state.

export interface AnalyticsFailureDrillState {
  analyticsFailureDrill: true;
}

/** The exact state object to pass to ``navigate(url, { state })`` on drill. */
export const ANALYTICS_FAILURE_DRILL_STATE: AnalyticsFailureDrillState = {
  analyticsFailureDrill: true,
};

/** Type guard — true only for a genuine Analytics failure-category drill. */
export function isAnalyticsFailureDrill(
  state: unknown,
): state is AnalyticsFailureDrillState {
  return (
    typeof state === 'object' &&
    state !== null &&
    (state as { analyticsFailureDrill?: unknown }).analyticsFailureDrill === true
  );
}
